import Vue from "vue";
import Component from "vue-class-component";
import $ from "jquery";
import { ServicesFactoryInstance } from "../../Controls/ServicesFactory";

@Component
export default class ModalCalculBulletin extends Vue {
	public currentData?: Blob = undefined;
	public currentDataUrl?: string = undefined;
	public dataReady = true;

	public annuler(): void {
		$("#modalCalculBulletin").modal("hide");
	}

	public getBuletin(idContrat: any): void {
    	this.currentData = undefined;
    	this.currentDataUrl = undefined;
    	this.dataReady = false;
    	ServicesFactoryInstance.CalculPaieService.getBulletinMoisCourantPdf(idContrat, data => {
    		this.currentData = data;
    		this.currentDataUrl = URL.createObjectURL(this.currentData);
    		this.dataReady = true;
    		this.$forceUpdate();
    	});
	}
}




// WEBPACK FOOTER //
// ./src/components/saisieDesVariables/modalCalculBulletin/modalCalculBulletin.ts